<template>
    <div class="mi_adSource-box">
        <div class="mi_adSource" v-loading="mi_adSource_loading">
            <div class="con">
                <div class="top">
                    <p style="display: none;">{{ computedKey }}</p>
                    <el-form :model="formData" label-width="60px">
                        <el-form-item label="产品" required>
                            <listCheck v-model="formData.app_id" :list="productList" label="创意组"
                                @change="handleProductChange" />
                        </el-form-item>
                        <el-form-item label="版位" required>
                            <listCheck v-model="formData.display_type" :list="display_type_list" label="创意组"
                                @change="handleDisplayChange" />
                        </el-form-item>
                        <el-form-item label="素材规格">
                            <listCheck v-model="formData.emi_material_type" :list="emi_material_type_list" label="创意组"
                                @change="handleMateriaChange" />
                        </el-form-item>
                        <!-- <el-form-item label="创意类型">
                            <listCheck v-model="formData.placement_type" :list="placement_type_list"
                                @change="handlePlacementChange" />
                                <div v-if="typeTip&&placement_type_list.length" class="el-form-item__error">{{typeTip}}</div>
                        </el-form-item> -->
                    </el-form>

                </div>
                <!-- v-loading="leftUploadLoading" -->
                <el-form v-show="tf_show_text" :model="formData" label-width="60px"
                    v-for="(item, index) in Object.keys(ad_group_list)" :key="index" @submit.native.prevent>
                    <el-form-item label="创意类型"
                        v-show="item == getAdGroupKey && !ad_group_list[getAdGroupKey]['tf_status']">
                        <p style="font-size: 12px;color: rgb(110 110 110);padding: 4px 0 8px 0;">该版位为无图创意广告，请设置创意数量</p>
                        <el-input-number :value="idea_num" :min="1" :max="10" :step="1" step-strictly :key="elInputNumberKeys"
                        @change="(currentValue, oldValue) => handleSwith(currentValue, oldValue, item)"
                            v-loading="leftUploadLoading"></el-input-number>
                    </el-form-item>
                </el-form>

                <div class="view" v-show="!tf_show_text">
                    <div class="left">
                        <el-tabs v-model="activeName" class="mi-table-upload">
                            <el-tab-pane name="first">
                                <span slot="label">工单素材<i class="el-icon-refresh" @click="handleReload"></i></span>
                            </el-tab-pane>
                            <el-tab-pane label="本地上传" name="second">
                            </el-tab-pane>
                        </el-tabs>
                        <div class="intelligent-btn"> <el-button type="primary" @click="handleIntelligent">智能选素材</el-button> </div>
                        <div class="library" id="mi_create_gd_height" v-show="activeName == 'first'">
                            <div class="form">
                                <ESelect v-model="value" placeholder="请选择" class="input-with-select mb10"
                                    @change="handleGd">
                                    <el-option v-for="item in options" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </ESelect>
                                <el-input placeholder="请输入素材或项目名称搜索" v-model="search" class="input-with-input mb10"
                                    @change="handleSearch">
                                    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                                </el-input>
                                 <el-select v-model="is_use" placeholder="素材状态" class="input-with-select"  clearable @change="handleGd">
                                    <!-- ideaGlobal.searchConfigData.material_status_map -->
                                    <el-option
                                        v-for="item in searchConfigData.material_status_map"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                                <el-select class="input-with-select ml8" v-model="plat_id" multiple clearable collapse-tags placeholder="素材渠道" filterable @change="handleGd">
                                    <!-- ideaGlobal.searchConfigData.plat_map -->
                                    <el-option
                                        v-for="item in searchConfigData.plat_map"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>

                            <div class="list-wrap" v-loading="left_loading">
                                <div class="list" v-if="left_list.length != 0">
                                    <div class="item" v-for="(ele, index) in left_list" :key="index">
                                        <WorkOrder :params="ele" :key="index"
                                            @preview="(target, type) => handleViewsWorkOrder(target, type, ele)"
                                            @add="handleAdd(ele)" />
                                    </div>
                                </div>
                                <div class="no_data" v-else>
                                    暂无数据
                                </div>
                            </div>


                            <div style="height: 30px;text-align: right;margin: 8px 0 0px 0;"
                                v-if="left_list.length != 0">
                                <el-pagination layout="prev, pager, next" :total="total" :page-size="pageSize"
                                    :current-page="currentPage" @current-change="handleCurrentChange"
                                    :disabled="left_loading">
                                </el-pagination>
                            </div>
                        </div>

                        <div v-loading="leftUploadLoading" v-show="activeName == 'second'">
                            <div class="upload-wrap" v-show="activeName == 'second'"
                                v-for="(item, index) in Object.keys(ad_group_list)" :key="index">

                                <div class="source-upload" v-show="item == getAdGroupKey">
                                    <el-button type="warning" size="mini" class="closeUpload"
                                        @click="handleCloseUpload(index)"
                                        v-show="ad_group_list[getAdGroupKey].uploadLoading">取消上传</el-button>
                                    <!-- {{ item }} - {{ getAdGroupKey }} -{{ ad_group_list[getAdGroupKey].uploadLoading }}  -->
                                    <el-upload class="upload-mi" drag :show-file-list="false" ref="elupload"
                                        :data="getUploadData(item)"
                                        :on-change="(file, fileList) => handleUploadChange(file, fileList, item)"
                                        :before-upload="(file) => handleUpload(file, item, ad_group_list[getAdGroupKey] ? ad_group_list[getAdGroupKey]['source_params'] : [])"
                                        :on-success="(res, file, fileList) => handleSuccess(res, item, fileList)"
                                        :on-error="(error, file, fileList) => handleError(error, file, fileList, item)"
                                        :on-progress="(event, file, fileList) => handleProgress(event, file, fileList, item)"
                                        action="/td/api/mi/batch/v2/upload" multiple :limit="500"
                                        :on-exceed="handleExceed">
                                        <i class="el-icon-upload"></i>
                                        <div class="el-upload__text">
                                            <p>将文件拖到此处，或<em>点击上传</em>
                                                <el-button type="text"
                                                    :loading="ad_group_list[getAdGroupKey].uploadLoading">
                                                </el-button>
                                                <!-- <el-button type="text"
                                                    v-if="ad_group_list[getAdGroupKey].alreadyfileList && ad_group_list[getAdGroupKey].alreadyfileList.length != ad_group_list[getAdGroupKey].AllfileList.length"
                                                    >
                                                    {{ ad_group_list[getAdGroupKey].alreadyfileList.length }}/{{ad_group_list[getAdGroupKey].AllfileList.length}}
                                                </el-button> -->
                                            </p>
                                            <div class="el-upload__tip" slot="tip" :style="{ paddingBottom: '10px' }">
                                                <div v-for="(desc, desc_index) in ad_group_list[getAdGroupKey] ? ad_group_list[getAdGroupKey]['source_params'] : []"
                                                    :key="desc_index">
                                                    <p v-if="desc['config_type'] == 3">
                                                         视频{{getFixedData(desc).text}}；{{getFixedData(desc).symbol}}{{ desc.conf_resolution }}；
                                                        <{{ desc.conf_size_name }}；{{ desc.conf_length }}秒；{{ desc.conf_format }}
                                                            </p>
                                                            <p v-if="desc['config_type'] == 1">
                                                                图片{{getFixedData(desc).text}}；{{getFixedData(desc).symbol}}{{ desc.conf_resolution }}；
                                                                <{{ desc.conf_size_name }}；{{ desc.conf_format }} </p>
                                                </div>
                                            </div>
                                        </div>
                                    </el-upload>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="right-top">
                            <div class="title">
                                已上传创意<span>每一行为一组创意，每一组必填的素材尺寸不可有空</span>
                                <el-button type="text" size="mini" style="color: #409EFF;"
                                    @click="handleClear">清空</el-button>
                            </div>
                        </div>
                        <div v-loading="leftUploadLoading">
                            <el-table :style="{ width: '98%', margin: '0 auto' }" :key="certinfoKey" height="40">
                                <!-- <el-table-column width="60">
                                    <template slot="header" slot-scope="scope">
                                        <span>序号</span>
                                    </template>
                                </el-table-column>
                                <el-table-column width="180" v-if="source_params.some(item => item.config_type == 3)">
                                    <template slot="header" slot-scope="scope">
                                        <span><span style="color: red;padding-right: 4px;">*</span>视频</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    v-if="source_params.some(item => item.config_type == 1) || source_params.length >= 2">
                                    <template slot="header" slot-scope="scope">
                                        <div><span style="color: red;padding-right: 4px;">*</span>图片
                                            <el-button v-if="getSourceVideo" type="primary" size="mini" plain
                                                class="zdsc" :loading="zdsc_loading"
                                                @click="handleAuto(getAdGroupKey, ad_group_list[getAdGroupKey] ? ad_group_list[getAdGroupKey]['material_list'] : [])">
                                                自动生成
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column> -->

                                <el-table-column width="60">
                                    <template slot="header" slot-scope="scope">
                                        <span>序号</span>
                                    </template>
                                </el-table-column>
                                <el-table-column :width="item.config_type == '1' ? '' : 180" :prop="item.config_type" v-for="(item, index_header) in source_params" :key="index_header">
                                    <template slot="header" slot-scope="scope">
                                        <div><span style="color: red;padding-right: 4px;">*</span>{{item.config_type == '1' ? '图片':'视频'}}
                                            <el-button v-if="item.config_type == '1' && getSourceVideo" type="primary" size="mini" plain class="zdsc"
                                                :loading="zdsc_loading"
                                                @click="handleAuto(getAdGroupKey, ad_group_list[getAdGroupKey] ? ad_group_list[getAdGroupKey]['material_list'] : [])">
                                                自动生成
                                            </el-button>
                                        </div>
                                    </template>
                                </el-table-column>

                            </el-table>
                            <div class="upload-view" :style="{ height: tableHeight }">
                                <div>
                                    <el-table :data="tableData" :style="{ width: '98%', margin: '0 auto' }"
                                        :show-header="false" :key="certinfoKey">
                                        <!-- <el-table-column label="序号" width="60">
                                            <template slot-scope="scope">
                                                <span>{{ ad_group_list[getAdGroupKey]['material_list'].length -
                                                    scope.$index }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="视频" width="180"
                                            v-if="source_params.some(item => item.config_type == 3)">
                                            <template slot-scope="scope">
                                                <div>
                                                    <div class="upload-item"
                                                        v-if="getCurTableColunmItem(scope.row, 3).length != 0 && getCurTableColunmItem(scope.row, 3)[0].material_url">
                                                        <ReadlyUploadOrder
                                                            :params="getCurTableColunmItem(scope.row, 3)[0]"
                                                            @del="handleDel(scope.$index, 3)"
                                                            @preview="(target, type) => handleViews(target, type, getCurTableColunmItem(scope.row, 3)[0])" />
                                                    </div>
                                                    <div class="upload-item" v-else>视频</div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="图片"
                                            v-if="source_params.some(item => item.config_type == 1) || source_params.length >= 2">
                                            <template slot-scope="scope">
                                                <div>
                                                    <div class="upload-item"
                                                        v-if="getCurTableColunmItem(scope.row, 1).length != 0 && getCurTableColunmItem(scope.row, 1)[0].material_url">
                                                        <ReadlyUploadOrder
                                                            :params="getCurTableColunmItem(scope.row, 1)[0]"
                                                            @del="handleDel(scope.$index, 1)"
                                                            @preview="(target, type) => handleViews(target, type, getCurTableColunmItem(scope.row, 1)[0])" />
                                                    </div>
                                                    <div class="upload-item" v-else>图片</div>
                                                </div>
                                            </template>
                                        </el-table-column> -->

                                        <el-table-column label="序号" width="60">
                                            <template slot-scope="scope">
                                                <span>{{ tableData.length - scope.$index }}</span>
                                            </template>
                                        </el-table-column>

                                        <el-table-column :width="item.config_type == '1' ? '' : 180" :prop="item.config_type" v-for="(item, index_header) in source_params" :key="index_header">
                                            <template slot-scope="scope">
                                                <div>
                                                    <div class="upload-item" v-if="getCurTableColunmItem(scope.row, item.config_type).length != 0 && getCurTableColunmItem(scope.row, item.config_type)[0].material_url">
                                                        <ReadlyUploadOrder
                                                        :params="getCurTableColunmItem(scope.row, item.config_type)[0]"
                                                        @del="handleDel(scope.$index, item.config_type)"
                                                        @preview="(target, type)=>handleViews(target, type, getCurTableColunmItem(scope.row, item.config_type)[0])"
                                                        />
                                                    </div>
                                                    <div class="upload-item" v-else>{{item.config_type == '1' ? '图片':'视频'}}</div>
                                                </div>
                                            </template>
                                        </el-table-column>

                                    </el-table>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <div v-show="tf_show_text">
                    <!-- 不支持选择与上传创意素材 -->
                </div>

            </div>
            <div class="footer">
                <el-button @click="onClosed">取消</el-button>
                <el-button type="primary" @keydown.enter.native.prevent @click="onSubmit">保存</el-button>
            </div>
        </div>
        <div>
            <el-tooltip ref="cellTip" v-model="showTips" placement="top" effect="dark" :open-delay="0">
                <div class="tip-mi-content" slot="content">{{ tipContent }}</div>
            </el-tooltip>
        </div>
        <div>
            <el-popover placement="left" width="440" ref="mipopWorkerOrder" v-model="showPopperWorkerOrder"
                @hide="handleVideoPause">
                <div class="mi-pop-content">
                    <div v-html="popContent"></div>
                </div>
            </el-popover>
            <el-popover placement="left" width="440" ref="mipop" v-model="showPopper" @hide="handleVideoPause">
                <div class="mi-pop-content">
                    <div v-html="popContent"></div>
                </div>
            </el-popover>
        </div>
    </div>
</template>

<script>
import { debounce, throttle, cloneDeep, isEqual } from 'lodash'
import listCheck from './conversionDrawer/listCheck.vue'
import { tipModal } from './index'
import API from '@/api/marketManage/miBatchAuto'
import WorkOrder from './workOrder.vue'
import ReadlyUploadOrder from './readlyUploadOrder.vue'
import getMediaInfo from '@/libs/media';
// 引入mixin
import { selectAiMaterialMixin } from '@/views/marketingManagement/mixins'

export default {
    name: 'mi_adSource',
    components: {
        listCheck,
        WorkOrder,
        ReadlyUploadOrder
    },
    props: [
        'cbs',
        'config',
        'appList',
        'displayType',
        'edit_ad_group_list',
    ],
    mixins: [selectAiMaterialMixin],
    data() {
        return {
            mi_adSource_loading: true,
            result: {},
            typeTip: '',//创意类型提示
            ad_group_list: {}, //提交对象
            tf_show: 1,
            tf_status: 0,
            idea_num: 3, //无图创意数量
            tf_show_text: false,
            // tf_status: false, // 是否投放
            productList: [],
            display_type_list: [],
            emi_material_type_list: [],
            // placement_type_list: [],
            formData: {
                app_id: '',
                campaign_type: 1,  //投放范围
                product_type: 2,
                display_type: '',   //投放版位
                emi_material_type: '',  //素材规格
                // placement_type: [],    //创意类型
            },
            currentPage: 1,
            pageSize: 20,
            total: 0,
            left_loading: false,

            active: -1,
            activeName: 'first',
            options: [{
                value: '1',
                label: '视频：16:9,960*540'
            }, {
                value: '2',
                label: '图片：16:9,960*540'
            }
            ],
            value: '', //素材工单 下拉
            search: '', //素材工单 输入
            is_use: '',//素材工单 是否使用
            plat_id: '',//素材工单 媒体
            left_list: [],
            left_lists: [
                {
                    "material_name": "88783210-9685-11ef-8c79-ed0875f4bcff.jpg",
                    "material_url": "/WorkOrder/6731811f18c9c/88783210-9685-11ef-8c79-ed0875f4bcff.jpg",
                    "material_size": "55.25KB",
                    "material_duration": null,
                    "md5": "7678faa166e80f22c43fb00dea8f1405",
                    "crc_md5": "989438921245930697",
                    "width": "1280",
                    "height": "720",
                    "img_material_url": "/WorkOrder/6731811f18c9c/88783210-9685-11ef-8c79-ed0875f4bcff.jpg",
                    "project_name": "111",
                    "material_type": 1,
                    "full_material_url": "https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/6731811f18c9c/88783210-9685-11ef-8c79-ed0875f4bcff.jpg",
                    "size": "56572",
                    "duration": null,
                    "img_full_material_url": "https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/6731811f18c9c/88783210-9685-11ef-8c79-ed0875f4bcff.jpg"
                },
                {
                    "material_name": "8af58b50-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "material_url": "/WorkOrder/671a12eae0f50/8af58b50-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "material_size": "50.88KB",
                    "material_duration": null,
                    "md5": "4ff9df7c035c45d103e7aad9dcc9bab7",
                    "crc_md5": "12851087679255623",
                    "width": "960",
                    "height": "540",
                    "img_material_url": "/WorkOrder/671a12eae0f50/8af58b50-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "project_name": "我建筑贼6#￥我建筑贼6#￥我建筑贼6#￥！@#￥%！",
                    "material_type": 1,
                    "full_material_url": "https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/671a12eae0f50/8af58b50-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "size": "52096",
                    "duration": null,
                    "img_full_material_url": "https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/671a12eae0f50/8af58b50-91e9-11ef-a5c9-8589b3da9745.jpg"
                },
                {
                    "material_name": "7e81ad90-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "material_url": "/WorkOrder/671a12eac44e6/7e81ad90-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "material_size": "34.04KB",
                    "material_duration": null,
                    "md5": "a4024aeb8693c25dcbfcc396d0dc01b3",
                    "crc_md5": "997516384057218714",
                    "width": "960",
                    "height": "540",
                    "img_material_url": "/WorkOrder/671a12eac44e6/7e81ad90-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "project_name": "我建筑贼6#￥我建筑贼6#￥我建筑贼6#￥！@#￥%！",
                    "material_type": 1,
                    "full_material_url": "https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/671a12eac44e6/7e81ad90-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "size": "34852",
                    "duration": null,
                    "img_full_material_url": "https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/671a12eac44e6/7e81ad90-91e9-11ef-a5c9-8589b3da9745.jpg"
                },
                {
                    "material_name": "8087b6c0-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "material_url": "/WorkOrder/671a1271017bd/8087b6c0-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "material_size": "109.50KB",
                    "material_duration": null,
                    "md5": "76e738df74c7681476e64cf319836dd9",
                    "crc_md5": "7937247654229508",
                    "width": "960",
                    "height": "540",
                    "img_material_url": "/WorkOrder/671a1271017bd/8087b6c0-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "project_name": "我建筑贼6",
                    "material_type": 1,
                    "full_material_url": "https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/671a1271017bd/8087b6c0-91e9-11ef-a5c9-8589b3da9745.jpg",
                    "size": "112133",
                    "duration": null,
                    "img_full_material_url": "https://download.wmgm.gm825.net/cpd/test/plat/WorkOrder/671a1271017bd/8087b6c0-91e9-11ef-a5c9-8589b3da9745.jpg"
                },
            ],
            uploadData: [],
            source_params: [],
            upload_img_text: '',
            upload_video_text: '',
            zdsc_loading: false, //自动生成loading
            cur_zdsc: -1,
            notifyErrorList: [],  // 存储用户选择的上传错误
            selectedFileCount: 0, // 存储用户选择的文件数量
            timeoutId: '',
            fetch_timeoutId: '', // 工单列表 超时id
            listLoading: false,  // 工单素材loading  处理视频加载后
            leftUploadLoading: false,  // 工单素材loading  处理视频加载后
            certinfoKey: 1, //处理table更新
            showTips: false, //tips浮层提醒
            tipContent: '',
            showPopper: false, //popper浮层提醒
            showPopperWorkerOrder: false, //popper浮层提醒 工单
            popContent: '',
            showPopper_timeoutId: '',
            showPopper_timeoutId_WorkerOrder: '',
            tableHeight: 200,
            tableData: [],
            elInputNumberKeys: 1,
            searchConfigData: { material_status_map: [], plat_map: [] },
        }
    },
    computed: {

        // 计算当前选中的key
        getAdGroupKey() {
            if (this.formData.app_id != '' && this.formData.display_type != '' && this.formData.emi_material_type != '') {
                let cur_key = `${this.formData.app_id}_${this.formData.display_type}_${this.formData.emi_material_type}`
                return cur_key
            }
        },
        // 添加当前选中对象的key
        computedKey() {
            let all_keys = Object.keys(this.ad_group_list)
            if (this.formData.app_id != '' && this.formData.display_type != '' && this.formData.emi_material_type != '') {
                let cur_key = `${this.formData.app_id}_${this.formData.display_type}_${this.formData.emi_material_type}`
                if (!all_keys.includes(cur_key)) {
                    this.ad_group_list[cur_key] = {
                        // placement_type: [],
                        material_list: [],
                        source_params: [],
                        tf_status: false,
                        idea_num: 3,
                        uploadLoading: false,
                        AllfileList: [],
                        alreadyfileList: []
                    }
                }
                return this.ad_group_list
            }
        },
        getSourceVideo() {
            let is_video = this.source_params && this.source_params.some(item => item.config_type == 3)
            return is_video
        },
        getSourceTypeImg() {
            if (this.source_params && this.source_params.length > 1) {
                return true
            } else if (this.source_params && this.source_params.length == 1) {
                let is_img = this.source_params && this.source_params.some(item => item.config_type == 1)
                return is_img
            } else {
                return false
            }
        },
    },
    created() {
        const editPromise = new Promise((res, rej) => {
            this.productList = this.appList.map(item => {
                item['value'] = item['app_id']
                item['label'] = item['app_name']
                item['num'] = 0
                return item
            })
            this.display_type_list = this.displayType.map(item => {
                item['value'] = item['param_id']
                item['label'] = item['param_name']
                item['pid'] = item['pid']
                item['num'] = 0
                return item
            })
            res()
        })
        this.tf_show_text = true


        setTimeout(() => {
            if (this.edit_ad_group_list && Object.keys(this.edit_ad_group_list).length != 0) {
                this.ad_group_list = cloneDeep(this.edit_ad_group_list)
                this.handleProductChange(this.productList[0]['value'])
                this.$nextTick(() => { this.getAllNumber() })
                return
            }
            this.handleProductChange(this.productList[0]['value'])
        }, 10)

    },
    mounted() {
        // this.getTableHeight()
        // console.log(document.documentElement.clientHeight)
        window.addEventListener('resize', this.getTableHeight);
        this.getEventTip();
        this.getWorkOrderSearchConfig();
    },
    methods: {
         async getWorkOrderSearchConfig() {
            const { data } = await API.getWorkOrderSearchConfig();
            this.searchConfigData = data;
        },
        getTableHeight() {
            let mi_create_body = document.getElementById('mi_create_gd_height')
            if (mi_create_body) {
                let mi_height = mi_create_body.clientHeight - 45
                let document_height = document.documentElement.clientHeight - 460
                // console.log(mi_height, document_height)
                if (mi_height < document_height) {
                    this.tableHeight = `${document_height}px`
                } else {
                    this.tableHeight = `${mi_height}px`
                }

            }
        },
        getEventTip() {
            const _this = this;
            const cellTip = this.$refs.cellTip;
            // 超长提示事件
            $(this.$el).on('mouseenter', '.mi-work-order-title', debounce(function () {
                const $cell = $(this);
                if ($cell[0].clientWidth >= $cell[0].scrollWidth) {
                    return;
                }
                cellTip.referenceElm = $cell[0];
                _this.showTips = true;
                _this.tipContent = $cell.text();
            }, 200))
                .on('mouseleave', '.mi-work-order-title', debounce(function () {
                    if (!_this.showTips) {
                        return;
                    }
                    _this.$nextTick(() => {
                        _this.showTips = false;
                    })
                }, 200));
        },
        handleViews(target, type, els) {
            if (type == 'leave' || els.full_material_url == '') {
                this.showPopper = false
                return
            }

            this.showPopper = false
            const cellPop = this.$refs.mipop

            if (els.material_type == 1 || els.type == 1) {
                this.popContent = `<img class="mi-material" src="${els.full_material_url}">`
            } else if (els.material_type == 3 || els.type == 3) {
                this.popContent = `<video class="mi-material mi-popver-video item-view-video item-view-video-addlistnter"
                poster="${els.img_full_material_url}"
                src="${els.full_material_url}" controls  preload="metadata"></video>`
            }


            clearTimeout(this.showPopper_timeoutId)
            this.showPopper_timeoutId = setTimeout(() => {
                this.$nextTick(() => {
                    cellPop.referenceElm = cellPop.$refs.reference = target
                    this.showPopper = true;
                })
                clearTimeout(this.showPopper_timeoutId)
            }, 100);

        },
        handleViewsWorkOrder(target, type, els) {
            if (type == 'leave' || els.full_material_url == '') {
                this.showPopperWorkerOrder = false
                return
            }
            this.showPopperWorkerOrder = false
            const cellPop = this.$refs.mipopWorkerOrder

            if (els.material_type == 1 || els.type == 1) {
                this.popContent = `<img class="mi-material" src="${els.full_material_url}">`
            } else if (els.material_type == 3 || els.type == 3) {
                this.popContent = `<video class="mi-material mi-popver-video item-view-video item-view-video-addlistnter"
                poster="${els.img_full_material_url}"
                src="${els.full_material_url}" controls  preload="metadata"></video>`
            }


            clearTimeout(this.showPopper_timeoutId_WorkerOrder)
            this.showPopper_timeoutId_WorkerOrder = setTimeout(() => {
                this.$nextTick(() => {
                    cellPop.referenceElm = cellPop.$refs.reference = target
                    this.showPopperWorkerOrder = true;
                })
                clearTimeout(this.showPopper_timeoutId_WorkerOrder)
            }, 100);

        },
        getCurTableColunmItem(arr, index) {
            let res_arr = arr.filter(item => item.type == index)
            return res_arr
        },
        handleProductChange(value) {
            this.formData.app_id = value

            this.formData.emi_material_type = ''  //素材规格
            // this.placement_type_list = []        //创意规格数组
            // this.formData.placement_type = []    //创意类型

            let main_app_name_list = this.productList.filter(item => item.app_id == value)
            if (main_app_name_list.length != 0) {
                this.search = main_app_name_list[0]['main_app_name']
            }

            // 版位个数
            // const combinedKeyCondition = /^(\d+)_(\d+)/;
            // const combinedKeyResult = this.findArraysByCondition(this.ad_group_list, combinedKeyCondition);
            // let res_display_type_list = this.display_type_list.map(item => {
            //     let cur_item = combinedKeyResult[`${this.formData.app_id}_${item['value']}`]
            //     if(cur_item) {
            //         item['num'] = cur_item['lengthSum']
            //     }else{
            //         item['num'] = 0
            //     }
            //     return item
            // })
            // this.display_type_list = res_display_type_list

            let select_display_type = this.display_type_list.length != 0 ? this.display_type_list[0]['value'] : ''  //投放版位
            this.handleDisplayChange(select_display_type)

        },
        handleDisplayChange(value) {
            this.formData.display_type = value
            this.formData.emi_material_type = ''  //素材规格
            // this.placement_type_list = []        //创意规格数组
            // this.formData.placement_type = []    //创意类型

            let res_select = this.display_type_list.filter(item => item['value'] == value)
            this.formData.campaign_type = res_select[0]['pid'].split('_')[0]
            // const materialKeyCondition = /^(\d+)_(\d+)_(\d+)/;
            // const materialKeyResult = this.findArraysByCondition(this.ad_group_list, materialKeyCondition);

            if (this.formData.campaign_type != '' && this.formData.product_type != '' && this.formData.app_id != '' && value) {
                let res_list = this.config['emi_material_type'].filter(item => item['pid'] != 0 && item['pid'] == `${this.formData.campaign_type}_${this.formData.product_type}_${value}`).map(item => {
                    item['value'] = item['param_id']
                    item['label'] = item['param_name']
                    item['num'] = 0
                    return item
                })
                console.log('-----s', res_list)
                // let res_list_add_num = res_list.map(item => {
                //     let cur_item = materialKeyResult[`${this.formData.app_id}_${this.formData.display_type}_${item['value']}`]
                //     if(cur_item) {
                //         item['num'] = cur_item['lengthSum']
                //     }else{
                //         item['num'] = 0
                //     }

                //     return item
                // })
                this.emi_material_type_list = res_list
            }
            let select_emi_material_type = this.emi_material_type_list.length != 0 ? this.emi_material_type_list[0]['value'] : ''  //素材规格

            this.handleMateriaChange(select_emi_material_type)
        },
        handleMateriaChange(value) {
            this.formData.emi_material_type = value
            // let res_placement_type_list = this.config['placement_type'].filter(item => item['pid'] != 0 && item['pid'] == `${this.formData.campaign_type}_${this.formData.product_type}_${this.formData.display_type}_${this.formData.emi_material_type}`).map(item => {
            //     item['value'] = item['param_id']
            //     item['label'] = item['param_name']
            //     item['config'] = item['config']
            //     item['num'] = 0
            //     return item
            // })
            // this.placement_type_list = res_placement_type_list
            // console.log('---dangqian', res_placement_type_list)

            // setTimeout(() => {

            //     if(res_placement_type_list.length != 0) {
            //         if(res_placement_type_list[0]['config'] == 'true') {
            //             this.ad_group_list[this.getAdGroupKey]['tf_status'] = true
            //             // this.ad_group_list[this.getAdGroupKey]['idea_num'] = 3
            //         }else{
            //             this.ad_group_list[this.getAdGroupKey]['tf_status'] = false
            //             // this.ad_group_list[this.getAdGroupKey]['idea_num'] = null
            //         }
            //     }
            //     this.idea_num = this.ad_group_list[this.getAdGroupKey]['idea_num']


            // }, 10);

            // setTimeout(()=>{
            //     if(this.ad_group_list[this.getAdGroupKey].placement_type && this.ad_group_list[this.getAdGroupKey].placement_type.length != 0) {
            //         this.formData.placement_type = this.ad_group_list[this.getAdGroupKey].placement_type
            //     }else{
            //         this.formData.placement_type = res_placement_type_list.map(item=>item.value)    //创意类型
            //     }

            //     this.placementSelect()
            // }, 20)
            this.placementSelect()

        },
        // 创意类型的默认勾选
        placementSelect() {
            let obj = {
                campaign_type: this.formData.campaign_type,
                product_type: this.formData.product_type,
                display_type: this.formData.display_type,
                material_type_id: this.formData.emi_material_type
            }
            this.tableData = []

            this.left_loading = true
            this.leftUploadLoading = true
            clearTimeout(this.fetch_timeoutId)
            this.fetch_timeoutId = setTimeout(() => {
                this.fet_get_material_info(this.getAdGroupKey, obj)
                clearTimeout(this.fetch_timeoutId)
            }, 500);
            // if(this.ad_group_list[this.getAdGroupKey]['placement_type'].length != 0) {
            //     this.fetch_timeoutId = setTimeout(() => {
            //         this.fet_get_material_info(this.getAdGroupKey,obj)
            //         clearTimeout(this.fetch_timeoutId)
            //     }, 500);
            // }else{
            //     this.leftUploadLoading = false
            // }


        },
        handleSwith(currentValue, oldValue, key) {
            this.idea_num = currentValue ? Math.ceil(currentValue) : 1
            this.ad_group_list[key]['idea_num'] = currentValue ? Math.ceil(currentValue) : 1
            // this.ad_group_list[key]['status'] = !val ? 0 : 1
            this.elInputNumberKeys++
            console.log('----',currentValue, Math.ceil(currentValue))
            this.$nextTick(() => { this.getAllNumber() })
        },
        handleReload() {
            // this.search = ''
            this.currentPage = 1
            this.total = 0
            this.fet_get_works_order_list()
        },
        // 滚动加载
        loadMoreData() {

        },
        // 计算超出文字 显示pop 否则 不显示
        // showTips(id) {
        //     let el_tips = document.getElementById(id)
        //     if (el_tips) {
        //         if (el_tips.scrollWidth > el_tips.clientWidth) {
        //             return false
        //         } else {
        //             return true
        //         }
        //     } else {
        //         return true
        //     }
        // },
        //视频暂停
        handleVideoPause() {
            const videoList = document.querySelectorAll('.mi-popver-video')
            videoList && videoList.forEach(item => {
                item.pause();
            })
        },
        //视频加载成功 处理
        videoSuccess() {
            const videoList = document.querySelectorAll('.item-view-video-addlistnter')
            if (videoList && videoList.length == 0) {
                // this.left_loading = false
                return
            }

            const videoPromise = new Promise((res, rej) => {
                videoList.forEach(item => {
                    // item.addEventListener('loadedmetadata', ()=>{
                    //     this.left_loading = false
                    // });
                    item.addEventListener('loadeddata', () => {
                        // this.left_loading = false
                    });
                    item.addEventListener('error', () => {
                        item.style.display = 'none';
                        // this.left_loading = false
                    });
                    res()
                })
            })
            // videoPromise.then(()=>{
            //     console.log('================')
            //     this.left_loading = false
            // })
        },
        //视频加载失败 处理
        // videoError() {
        //     const videoList = document.querySelectorAll('.item-view-video')
        //     if(videoList && videoList.length == 0) {
        //         this.left_loading = false
        //         return
        //     }
        // },
        findArraysByCondition(data, condition) {
            const result = {};
            for (const key in data) {
                const matches = key.match(condition);
                if (matches) {
                    const combinedKey = matches.slice(1).join("_");
                    const materialList = data[key].material_list;
                    const placementtypelength = 1
                    const lengthSum = materialList.length * placementtypelength;

                    const cur_idea_num = data[key].idea_num

                    if (!result[combinedKey]) {
                        result[combinedKey] = {
                            arrays: [],
                            lengthSum: 0
                        };
                    }

                    if (data[key].tf_status == true) {
                        result[combinedKey].arrays.push(data[key]);
                        result[combinedKey].lengthSum += lengthSum;
                    } else {
                        result[combinedKey].arrays = []
                        result[combinedKey].lengthSum += cur_idea_num * placementtypelength
                    }

                }
            }

            return result;
        },
        // 产品 版位  素材规格 显示个数计算
        getAllNumber() {
            // 产品个数
            const firstNumberCondition = /^(\d+)_/;
            const firstNumberResult = this.findArraysByCondition(this.ad_group_list, firstNumberCondition);
            let res_productList = this.productList.map(item => {
                // if (item.value == this.formData.app_id) {
                //     item['num'] = firstNumberResult[item['value']]['lengthSum']
                // }
                let isfirstNumberResult = firstNumberResult[item['value']]
                if (isfirstNumberResult) {
                    item['num'] = firstNumberResult[item['value']]['lengthSum']
                }
                return item
            })
            this.productList = res_productList

            // 版位个数
            const combinedKeyCondition = /^(\d+)_(\d+)/;
            const combinedKeyResult = this.findArraysByCondition(this.ad_group_list, combinedKeyCondition);

            let res_display_type_list = this.display_type_list.map(item => {
                // if (item.value == this.formData.display_type) {
                //     item['num'] = combinedKeyResult[`${this.formData.app_id}_${item['value']}`]['lengthSum']
                // }
                let iscombinedKeyResult = combinedKeyResult[`${this.formData.app_id}_${item['value']}`]
                if (iscombinedKeyResult) {
                    item['num'] = combinedKeyResult[`${this.formData.app_id}_${item['value']}`]['lengthSum']
                }

                return item
            })
            this.display_type_list = res_display_type_list

            // 素材规格个数
            const materialKeyCondition = /^(\d+)_(\d+)_(\d+)/;
            const materialKeyResult = this.findArraysByCondition(this.ad_group_list, materialKeyCondition);

            let res_emi_material_type_list = this.emi_material_type_list.map(item => {
                // if (item.value == this.formData.emi_material_type) {
                //     item['num'] = materialKeyResult[`${this.formData.app_id}_${this.formData.display_type}_${item['value']}`]['lengthSum']
                // }
                let ismaterialKeyResult = materialKeyResult[`${this.formData.app_id}_${this.formData.display_type}_${item['value']}`]
                if (ismaterialKeyResult) {
                    item['num'] = materialKeyResult[`${this.formData.app_id}_${this.formData.display_type}_${item['value']}`]['lengthSum']
                }
                return item
            })
            this.emi_material_type_list = res_emi_material_type_list
        },
        //工单素材 change
        handleGd(value) {
            if (this.leftUploadLoading) return
            this.currentPage = 1
            this.total = 0
            this.fet_get_works_order_list()
        },
        //工单素材 查询
        handleSearch(val) {
            if (this.leftUploadLoading) return
            this.currentPage = 1
            this.total = 0
            this.fet_get_works_order_list()
        },
        //工单素材 添加
        handleAdd(item) {
            let key = this.getAdGroupKey
            let identifying = `gd_${new Date().valueOf()}`
            this.add(item, key, identifying)
        },
        // 添加逻辑
        add(item, cur_key, cur_time) {
            const cur_list = this.ad_group_list[cur_key]?.material_list || [];
            const existingIndex = cur_list.findLastIndex(arr => arr.some(i => i.material_url === '' && i.type == item.material_type));

            if (existingIndex !== -1) {
                const targetItem = cur_list[existingIndex].find(i => i.material_url === '');
                if (targetItem) {
                    Object.assign(targetItem, {
                        material_name: item.material_name || '',
                        material_url: item.material_url || '',
                        full_material_url: item.full_material_url || '',
                        img_material_url: item.img_material_url || '',
                        img_full_material_url: item.img_full_material_url || '',
                        type: item.material_type || '',
                        material_md5: item.material_md5 || '',
                    });
                }
            } else {
                const newItems = this.source_params.map((param, index) => {
                    const newItem = {
                        material_name: item.material_type == param.config_type ? item.material_name : '',
                        material_url: item.material_type == param.config_type ? item.material_url : '',
                        full_material_url: item.material_type == param.config_type ? item.full_material_url : '',
                        img_material_url: item.material_type == param.config_type ? item.img_material_url : '',
                        img_full_material_url: item.material_type == param.config_type ? item.img_full_material_url : '',
                        type: param.config_type,
                        id: item.material_type == param.config_type ? `${cur_time}_${index}` : '',
                         material_md5: item.material_md5 || '',
                    };
                    return newItem;
                });

                cur_list.unshift(newItems);
                this.ad_group_list[cur_key].material_list = cur_list;
            }

            setTimeout(() => this.getAllNumber(), 0);
        },
        // 删除已上传
        handleDel(index, type) {
            let active = this.getAdGroupKey
            let cur_list = this.ad_group_list[active]['material_list']

            cur_list[index].forEach(item => {
                item
                if (item['type'] == type) {
                    item['material_name'] = ''
                    item['material_url'] = ''
                    item['full_material_url'] = ''
                    item['img_material_url'] = ''
                    item['img_full_material_url'] = ''
                }
            })

            let is_every = cur_list[index].every(item => item['material_url'] == '')
            if (is_every) {
                cur_list.splice(index, 1)
            }

            this.$nextTick(() => { this.getAllNumber() })
        },
        handleUploadChange(file, fileList) {

            // 更新用户选择的文件数量
            this.selectedFileCount = fileList.length;
            // console.log('fileList', fileList)
        },
        getMulErrText(mulErr) {
            if (!Array.isArray(mulErr) || mulErr.length <= 0) return '';
            let pHtml = mulErr.map(item => `<div><p style="color:#333;line-height: 1.2;margin-bottom: 6px;" class="font12px">${item.name}</p><p style="color:#333;line-height: 1.2;margin-bottom: 6px;" class="font12px">${item.error}</p></div>`).join('');
            return `<div class="mi-notify-con">${pHtml}</div>`
        },
        // 重置校验参数 数组
        resizeUploadConfig(params) {
            let list_config = params.map(item => {
                let is_split_ratio = item['conf_resolution_ratio'].split(':')  // 比例
                let is_split_conf_resolution = item['conf_resolution'].split('*') //宽高

                item['format'] = item['conf_format'].toLocaleUpperCase().split('/')
                if (item.config_type == 3) {
                    item['format'] = ['MPEG-4']
                }
                if (is_split_ratio.length == 2) {
                    item['width_ratio'] = Number(is_split_ratio[0])
                    item['height_ratio'] = Number(is_split_ratio[1])
                    item['ratio'] = (Number(is_split_ratio[0]) / Number(is_split_ratio[1])).toFixed(2)
                }
                if (is_split_conf_resolution.length == 2) {
                    item['width'] = Number(is_split_conf_resolution[0])
                    item['height'] = Number(is_split_conf_resolution[1])
                }
                item['size'] = Number(item['conf_size'])

                return item
            })
            return list_config
        },
        // 宽高 大小 比例 校验
        valiUpload(list, res) {
            const isSize_img = list.every(item => item['size'] > res['fileSize'])
            if (!isSize_img) {
                return { name: res.name, error: '素材大小不符合' }
            }
            const isresolution_img = list.every(item => {
                 // 0:0 必须上传固定尺寸
                if (item.conf_resolution_ratio === '0:0') {
                    return  item.width ===res.width && item.height === res.height
                }else {
                     if(item['width'] > res['width'] || item['height'] > res['height']) {
                        return false
                    }else{
                        return true
                    }
                }
            })
            if (!isresolution_img) {
                return { name: res.name, error: '素材宽高尺寸不符合' }
            }

            let desired_ratio = (res['width'] / res['height']).toFixed(2)

            const isratio_img = list.every(item => {
                if (Math.abs(desired_ratio - item['ratio']) > 0.01) {
                    return false
                } else {
                    return true
                }
            })

            if (!isratio_img) {
                return { name: res.name, error: '素材比例不符合' }
            }
            return 'success'
        },
        // 1000 毫秒弹出
        throttleTime() {
            clearTimeout(this.timeoutId)
            if (this.notifyErrorList.length != 0) {
                this.timeoutId = setTimeout(() => {
                    let flag_mul_err_html = this.getMulErrText(this.notifyErrorList)
                    this.$notify.error({
                        title: '错误',
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_mul_err_html,
                        customClass: 'mi-notify'
                    });

                    this.notifyErrorList = []
                    clearTimeout(this.timeoutId)
                }, 1000);
            }
        },
        // 上传前 校验
        handleUpload(file, cur_select_id, prop_fileConfigs) {
            let fileConfigs = this.resizeUploadConfig(prop_fileConfigs)
            let de_file = file
            this.ad_group_list[cur_select_id].alreadyfileList = []
            this.ad_group_list[cur_select_id].AllfileList = []
            return new Promise((resolve, reject) => {
                getMediaInfo(de_file).then((result) => {
                    let media_result = result
                    media_result['name'] = de_file.name
                    const isFormat = fileConfigs.some(item => item['format'].includes(media_result['format']))
                    const video_list = fileConfigs.filter(item => item['config_type'] == 3)
                    const img_list = fileConfigs.filter(item => item['config_type'] == 1)
                    if (!isFormat) {
                        this.notifyErrorList.push({ name: media_result['name'], error: '素材格式不符合' })
                        reject()
                        this.throttleTime()
                        return
                    }
                    if (media_result['format'] == 'MPEG-4') {
                        let vali_res = this.valiUpload(video_list, media_result)

                        if (vali_res != 'success') {
                            this.notifyErrorList.push(vali_res)
                            reject()
                            this.throttleTime()
                            return
                        }

                        // 视频时长单独判断
                        let conf_length = video_list[0]['conf_length']
                        if (conf_length && conf_length.indexOf('-') != -1) {
                            let is_split_conf_length = conf_length.split('-')
                            if (media_result['duration'] < Number(is_split_conf_length[0]) || media_result['duration'] > Number(is_split_conf_length[1])) {
                                this.notifyErrorList.push({ name: media_result['name'], error: '素材时长不符合' })
                                reject()
                                this.throttleTime()
                                return
                            }
                        } else if (conf_length) {
                            if (parseInt(media_result['duration']) != Number(conf_length)) {
                                this.notifyErrorList.push({ name: media_result['name'], error: '素材时长不符合' })
                                reject()
                                this.throttleTime()
                                return
                            }
                        }

                        // 通过校验
                        resolve()
                        clearTimeout(this.timeoutId)
                        return
                    }

                    if (de_file.type.includes('image')) {
                        let vali_res = this.valiUpload(img_list, media_result)

                        if (vali_res != 'success') {
                            this.notifyErrorList.push(vali_res)
                            reject()
                            this.throttleTime()
                            return
                        }

                        // 校验通过
                        resolve()
                        clearTimeout(this.timeoutId)
                        return
                    }

                })
            })

        },
        // 上传成功 回调
        handleSuccess(res, prop_id, fileList) {
            if (prop_id == '') return
            if (res.code == 200) {
                let identifying = `upload_${new Date().valueOf()}`
                let upload_items = {
                    material_name: res.data.name,
                    material_url: res.data.filePath,
                    full_material_url: res.data.fullFilePath,
                    img_material_url: res.data.img_material_url,
                    img_full_material_url: res.data.img_full_material_url,
                    material_type: res.data.ext == 'mp4' ? '3' : '1'
                }

                this.add(upload_items, prop_id, identifying)
            } else {
                this.$notify.error({
                    title: '错误',
                    message: res.info,
                    duration: 0
                });
            }
            this.ad_group_list[prop_id].alreadyfileList.push(prop_id)
            this.ad_group_list[prop_id].uploadLoading = false
            this.$forceUpdate();
        },
        // 上传失败 回调
        handleError(error, file, fileList, prop_id) {
            this.$message.error('文件上传失败：' + file.name);
            this.ad_group_list[prop_id].alreadyfileList.push(prop_id)
            this.ad_group_list[prop_id].uploadLoading = false
            this.$forceUpdate();
        },
        // 上传中 回调
        handleProgress(event, file, fileList, prop_id) {
            this.ad_group_list[prop_id].uploadLoading = true
            this.$forceUpdate();
        },
        // 取消上传
        handleCloseUpload(index) {
            this.$refs.elupload[index].abort();
            this.ad_group_list[this.getAdGroupKey].uploadLoading = false
            this.$forceUpdate();
        },
        handleExceed(files, fileList) {
            console.log('自定义上传传的个数', fileList, this.fileList)
        },
        // 视频自动生成封面
        handleAuto(cur_key, ele) {

            let find_no_img = ele.filter(item => {
                let isvideo = item.some(itemc => itemc.type == 3)
                let isNoImg = item.some(itemc => itemc.type != 3 && itemc.material_url == '')
                if (isvideo && isNoImg) {
                    return true
                } else {
                    return false
                }
            })
            let times = find_no_img.length

            if (times == 0) {
                this.$message.warning('没有需要自动生成的图片')
                return
            }

            ele.map(item => {
                let suoluoList = item.filter(itemc => itemc.type == 3)
                let name_split = suoluoList[0].img_material_url.split('/')
                let name_split_length = name_split && name_split.length
                let get_material_name = name_split[name_split_length - 1]
                suoluoList && item.map(item_leve2 => {
                    if ((item_leve2.type == 1 || item_leve2.type == '') && item_leve2.material_url == '') {
                        item_leve2.material_url = suoluoList[0].img_material_url
                        item_leve2.full_material_url = suoluoList[0].img_full_material_url
                        item_leve2.img_material_url = suoluoList[0].img_material_url
                        item_leve2.img_full_material_url = suoluoList[0].img_full_material_url
                        item_leve2.type = 1
                        item_leve2.material_name = get_material_name
                    }
                    return item_leve2
                })
                return item
            })



            this.zdsc_loading = true
            let new_find_no_img = ele.filter(item => {
                let isvideo = item.some(itemc=>itemc.type == 3)
                let isNoImg = item.some(itemc=>itemc.type !=3 && itemc.material_url == '')
                if(isvideo && isNoImg) {
                    return true
                }else{
                    return false
                }
            })
            this.callApiMultipleTimes(new_find_no_img.length, new_find_no_img, cur_key)
        },
        async callApiMultipleTimes(times, vidoe_arr, key) {
            if (times <= 0) {
                console.log("All API calls completed", times);
                this.cur_zdsc = times
                this.zdsc_loading = false
                // this.$message.warning('暂无可生成的视频');
                // this.$message.warning('没有需要自动生成的图片')
                return;
            }
            this.cur_zdsc = times
            let cur_material_arr = vidoe_arr[times - 1]
            let cur_material_url = cur_material_arr && cur_material_arr.filter(item => item.type == 3)
            try {
                let response = await this.callApi(cur_material_url[0]['material_url'], cur_material_url[0]['id'], key); // 调用接口并等待结果返回

                await this.callApiMultipleTimes(times - 1, vidoe_arr, key); // 递归调用下一次
            } catch (error) {
                await this.callApiMultipleTimes(times - 1, vidoe_arr, key); // 递归调用下一次
                this.$message.error(error.info);
            }
        },
        async callApi(video_url, id, key) {
            // https://download.wmgm.gm825.net/cpd/developmet/plat/batch/20240327/6603cd4921827/6603cd493f08f.mp4
            // /batch/20240327/6603cdda5e735/6603cdda7ba5c.mp4
            const response = await API.postMiVideoFirstImg({
                video_url: video_url,
                plat_id: 7
            }).then(res => {
                let cur_list = this.ad_group_list[key]['material_list']
                for (let i = cur_list.length - 1; i >= 0; i--) {
                    let children_arr = cur_list[i]
                    for (let j = 0; j < children_arr.length; j++) {
                        if (children_arr[j].id == id && children_arr[j].type != 3 && children_arr[j].material_url == '') {
                            children_arr[j].material_name = res.data.basename
                            children_arr[j].material_url = res.data.filePath,
                                children_arr[j].full_material_url = res.data.fullFilePath,
                                children_arr[j].img_material_url = res.data.filePath
                            children_arr[j].img_full_material_url = res.data.fullFilePath
                            children_arr[j].type = 1
                        }
                    }
                }
                this.$forceUpdate();
            })
            return response
        },

        // 上传额外参数
        getUploadData(prop_id) {
            let spilt_prop_id = prop_id.split('_')
            let res_split_display_type = ''
            // let res_plac_ids = this.ad_group_list[prop_id]['placement_type']
            if (spilt_prop_id.length == 3) {
                res_split_display_type = spilt_prop_id[1]
            }
            return {
                campaign_type: this.formData.campaign_type,
                product_type: this.formData.product_type,
                display_type: res_split_display_type ? res_split_display_type : '',
                // placement_type_ids: res_plac_ids ? res_plac_ids : [],
                material_type_id: this.formData.emi_material_type
            }
        },
        // 获取素材规格对应的素材尺寸信息
        fet_get_material_info(cur_key, obj) {

            API.getMiMaterialInfo({
                campaign_type: obj['campaign_type'],
                product_type: obj['product_type'],
                display_type: obj['display_type'],
                material_type_id: obj['material_type_id']
            }).then(res => {
                let result = res.data.list

                this.source_params = result
                this.typeTip = res.data.tip

                this.mi_adSource_loading = false
                this.leftUploadLoading = false
                this.tableData = this.ad_group_list[this.getAdGroupKey]['material_list']
                if (result.length != 0) {
                    let first_select = this.source_params.findIndex(item => item.config_type == 3)
                    if (first_select != -1) {
                        this.value = first_select
                    } else {
                        this.value = 0
                    }
                    this.tf_show_text = false
                    this.ad_group_list[cur_key]['tf_status'] = true
                    this.idea_num = this.ad_group_list[this.getAdGroupKey]['idea_num']
                } else {
                    this.value = ''
                    this.tf_show_text = true
                    this.ad_group_list[cur_key]['tf_status'] = false
                    this.idea_num = this.ad_group_list[this.getAdGroupKey]['idea_num']
                    return
                }

                if (Object.keys(this.ad_group_list[cur_key]).length != 0) {
                    this.ad_group_list[cur_key]['source_params'] = result
                }

                this.options = result.map((item, index) => {
                    let obj = {}
                    obj['value'] = index
                    const { text, symbol } = this.getFixedData(item)
                    if (item.config_type == 1) {
                        obj['label'] = `图片${text}；${symbol}${item.conf_resolution}；<${item.conf_size_name}；${item.conf_format}`
                    } else if (item.config_type == 3) {
                        obj['label'] = `视频${text}；${symbol}${item.conf_resolution}；<${item.conf_size_name}；${item.conf_length}秒；${item.conf_format}`
                    }
                    return obj
                })
                this.certinfoKey++


                this.$forceUpdate()

            }, err => {
                this.leftUploadLoading = false
                this.$message.error(err.info);
            }).then(() => {
                this.fet_get_works_order_list()
            }).finally(() => {
                this.$nextTick(() => { this.getAllNumber() })
            })
        },
        getFixedData(item) {
            const isFixed = item.conf_resolution_ratio === '0:0';
            const conf_resolution_ratio_text =  `${isFixed?'固定尺寸': item.conf_resolution_ratio}`
            return {
                text: conf_resolution_ratio_text,
                symbol: isFixed?'=':'≥'
            }
        },
        // 获取工单素材
        fet_get_works_order_list() {
            let select_value = 0
            if (this.source_params.length != 0) {
                if (this.value != '') {
                    select_value = this.value
                } else {
                    select_value = 0
                }
            } else {
                return
            }
            this.left_loading = true
            this.listLoading = true

            let conf = [{
                config_type: this.source_params[select_value].config_type,  //素材类型
                conf_resolution: this.source_params[select_value].conf_resolution,  //尺寸
                conf_resolution_ratio: this.source_params[select_value].conf_resolution_ratio, //比例
                conf_format: this.source_params[select_value].conf_format,  //格式
                conf_size: this.source_params[select_value].conf_size,
            }]
            let res_app_ids = this.appList.map(item => item.app_id)
            let params = {
                conf:conf,
                plat_id: this.plat_id,
                is_used: this.is_use,
                search: this.search,   // 搜索内容
                pn: this.currentPage,
                rn: this.pageSize,
                app_id: res_app_ids
            }
            let cur_video = this.source_params.findIndex(item => item.config_type == 3)

            if (cur_video != -1) {
                let cur_video_list = this.source_params.filter(item => item.config_type == 3)
                params['conf'][0]['conf_length'] = cur_video_list[0].conf_length
            }
            API.postMiWorkOrderList(params).then(res => {
                this.left_list = res.data.list
                this.total = res.data.totalCnt

                this.listLoading = false
                this.left_loading = false



                this.$nextTick(() => {
                    this.videoSuccess()
                    this.getTableHeight()
                    // this.videoError()
                })


            }, err => {
                this.listLoading = false
                this.$message.error(err.info);
                this.left_loading = false
            })
        },

        // 视频自动生成封面
        fet_out_img() {
            API.postMiVideoFirstImg({
                video_url: ''
            })
        },
        handleCurrentChange(val) {
            this.currentPage = val
            this.fet_get_works_order_list()
        },
        // 提示弹框
        showTip(tip, list) {
            tipModal({
                props: {
                    tip,
                    list
                }
            })
        },
        // 清空
        handleClear() {
            let active = this.getAdGroupKey
            this.ad_group_list[active]['material_list'] = []
            this.tableData = this.ad_group_list[active]['material_list']
            this.$nextTick(() => {
                this.getAllNumber()
                this.$forceUpdate()
            })
            // setTimeout(() => {

            // }, 0);
        },
        // 保存
        onSubmit() {
            let new_ad_group_list = {}
            let new_arr = Object.keys(this.ad_group_list)
            // console.log('-----过滤前结果', this.ad_group_list)
            new_arr.forEach(item => {
                if (!this.ad_group_list[item].tf_status || this.ad_group_list[item].material_list.length != 0) {
                    new_ad_group_list[item] = {
                        // placement_type: this.ad_group_list[item].placement_type,
                        material_list: this.ad_group_list[item].material_list,
                        source_params: this.ad_group_list[item].source_params,
                        tf_status: this.ad_group_list[item].tf_status,
                        idea_num: this.ad_group_list[item].idea_num,
                        uploadLoading: this.ad_group_list[item].uploadLoading,
                        AllfileList: this.ad_group_list[item].AllfileList,
                        alreadyfileList: this.ad_group_list[item].alreadyfileList
                    }
                }
            })

            // 版位个数
            let emit_list = this.productList.map(item => {

                const combinedKeyCondition = /^(\d+)_(\d+)/;
                const combinedKeyResult = this.findArraysByCondition(new_ad_group_list, combinedKeyCondition);

                let res_display_type_list = []
                this.display_type_list.forEach(item_c => {

                    let cur_item = combinedKeyResult[`${item.app_id}_${item_c['value']}`]
                    let obj = {}
                    if (cur_item) {
                        obj['app_id'] = item_c['param_id']
                        obj['param_name'] = item_c['label']
                        obj['param_id'] = item_c['param_id']
                        obj['num'] = cur_item['lengthSum'] ? cur_item['lengthSum'] : 0
                        obj['arrays'] = cur_item['arrays']
                    } else {
                        obj['app_id'] = item_c['param_id']
                        obj['param_name'] = item_c['label']
                        obj['param_id'] = item_c['param_id']
                        obj['num'] = 0
                        obj['arrays'] = []
                    }
                    res_display_type_list.push(obj)

                })

                item['children'] = res_display_type_list

                return item
            })
            // console.log('banwei', emit_list)
            let errList = {}
            let all_null = []

            let errList_material = {}
            let all_null_material = []
            emit_list.forEach(item => {
                let arr = []
                let arr_material = []
                item.children.forEach(itemc => {

                    if (itemc.num == 0) {
                        arr.push(itemc.param_name)
                        all_null.push(itemc.param_name)
                        errList[item.app_name] = arr
                    } else {
                        let res_material_arr_list = itemc.arrays
                        res_material_arr_list.forEach(m_item => {
                            if (m_item.tf_status) {
                                let is_material_null = m_item.material_list.some(m_item_c => {
                                    let cc_is_material_null = m_item_c.some(m_item_c_c => m_item_c_c['material_url'] == '')
                                    return cc_is_material_null
                                })
                                if (is_material_null) {
                                    arr_material.push(itemc.param_name)
                                    all_null_material.push(itemc.param_name)
                                    errList_material[item.app_name] = arr_material
                                }
                            }
                        })
                    }

                })

            })

            // console.log('-----当前结果', new_ad_group_list)


            if (all_null.length != 0) {
                this.showTip('存在未上传创意的版位，请检查，具体如下：', errList)
                return
            }

            if (all_null_material.length != 0) {
                this.showTip('存在必填项为空的创意版位，请检查，具体如下：', errList_material)
                return
            }




            // console.log('new_ad_group_list', new_ad_group_list)
            this.cbs.onSubmit({
                ad_group_list: new_ad_group_list,
                emit_list: emit_list
            })
        },
        onClosed() {
            let new_ad_group_list = {}
            let new_arr = Object.keys(this.ad_group_list)
            new_arr.forEach(item => {
                if (!this.ad_group_list[item].tf_status || this.ad_group_list[item].material_list.length != 0) {
                    new_ad_group_list[item] = {
                        // placement_type: this.ad_group_list[item].placement_type,
                        material_list: this.ad_group_list[item].material_list,
                        source_params: this.ad_group_list[item].source_params,
                        tf_status: this.ad_group_list[item].tf_status,
                        idea_num: this.ad_group_list[item].idea_num,
                        uploadLoading: this.ad_group_list[item].uploadLoading,
                        AllfileList: this.ad_group_list[item].AllfileList,
                        alreadyfileList: this.ad_group_list[item].alreadyfileList
                    }
                }
            })

            const result = isEqual(this.edit_ad_group_list, new_ad_group_list);
            if (Object.keys(new_ad_group_list).length != 0 && !result) {
                this.$confirm('取消后已经修改的内容不会保存，确认要取消吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$emit('close')
                }).catch(() => { });
            } else {
                this.$emit('close')
            }
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.getTableHeight)
    }
}
</script>

<style lang="scss" scoped>
.intelligent-btn {
    position: absolute;
    top: 4px;
    right: 10px;
}
.mi_adSource-box {
    height: 100%;
    width: 100%;
    overflow-x: auto;
}

.mi_adSource {
    padding: 0 20px;
    width: 1200px;
    height: 100%;
    display: flex;
    flex-direction: column;

    .con {
        height: 0;
        flex: 1;
        overflow: auto;

        .view {
            border: 1px solid #DCDFE6;
            // height: 100%;
            display: flex;

            // overflow: hidden;
            .left {
                position: relative;
                flex: 0 0 664px;
                border-right: 1px solid #DCDFE6;

                .library {
                    // height: 100%;
                    display: flex;
                    flex-direction: column;
                    padding: 0 8px;
                    margin-bottom: 20px;

                    .form {
                        height: 70px;
                        margin-top: 10px;
                        margin-bottom: 10px;

                        .input-with-select {
                            width: 280px;
                        }

                        .input-with-input {
                            width: 220px;
                            margin-left: 8px;
                        }
                    }

                    .source-upload {
                        padding: 8px;

                        .upload-mi {

                            .el-upload-dragger {
                                width: 100%;
                            }
                        }

                    }

                    .list-wrap {
                        // flex: 1;
                        // height: 0;
                        // overflow: auto;
                    }

                    .list {
                        display: flex;
                        flex-wrap: wrap;
                        min-height: 200px;

                        .item {
                            // padding: 8px;
                            // margin-right: 8px;
                            // margin-bottom: 8px;
                            // border: 1px solid #DCDFE6;
                            // flex: 0 1 150px;
                            // max-width: 200px;
                            flex-direction: column;
                            overflow: hidden;
                        }
                    }

                    .no_data {
                        min-height: 200px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #909399;
                    }
                }
            }

            .right {
                flex: 1;
                display: flex;
                flex-direction: column;

                .title {
                    padding: 0 8px;
                    font-size: 14px;
                    border-bottom: 2px solid #DCDFE6;
                    line-height: 40px;
                    height: 40px;

                    span {
                        font-size: 12px;
                        color: #a5a5a5;
                        padding-left: 8px;
                    }
                }

                .right-top {
                    height: 40px;

                    .title {
                        display: flex;
                        justify-content: space-between;
                    }
                }


                .upload-view {
                    height: 200px;
                    overflow-y: auto;
                    padding-top: 8px;
                    position: relative;

                    .zdsc {
                        margin-left: 8px;
                        position: absolute;
                        right: 90px;
                        top: 12px;
                        z-index: 9;
                    }

                    .upload-list {
                        display: flex;
                        align-items: center;
                        margin-bottom: 10px;

                        .upload-item-first.upload-item {
                            flex: 0 0 90px;
                            padding-left: 16px;
                        }

                        .upload-item {

                            flex: 1 0 auto;

                        }
                    }
                }
            }
        }
    }

    .upload-wrap {
        position: relative;

    }


    .footer {
        height: 60px;
        line-height: 60px;
        text-align: right;
        padding-right: 80px;
        margin: 0 -20px;
        box-shadow: 4px 0 4px #ccc;
    }

    .tip-mi-content {
        width: 200px;
    }
}
</style>
<style lang="scss">
.view .el-tabs__nav-wrap.is-top {
    padding: 0 8px;
}

.source-upload {
    padding: 8px;
    position: relative;

    .el-upload {
        width: 100%;
    }

    .closeUpload {
        position: absolute;
        top: -34px;
        left: 220px;
        z-index: 9;
    }

    .upload-mi {

        .el-upload-dragger {
            width: 100%;
            min-height: 220px;
        }
    }
}

.mi-pop-content {
    display: flex;
    justify-content: center;

    .mi-material {
        max-height: 320px;
        width: 100%;
        object-fit: contain;
        object-position: center;
    }
}

.mi-table-upload {
    .el-tabs__header {
        margin-bottom: 0;
    }
}

.mi-notify-con {
    word-wrap: break-word;
    width: 90%;
}
</style>
